<template>
  <div class="app-page--gray">
    <slot/>
    <br>
    <br>
    <br>
    <div class="mx-6">
      <div id="pre" class="max-w-screen-xl m-auto">
        <slot name="pre" />
      </div>
      <div class="relative my-10 gap-4 lg:gap-8 flex max-md:flex-wrap-reverse max-w-screen-xl w-full justify-center m-auto">
        <div class="inline-block relative w-full rounded-xl whitespace-pre-wrap">
          <slot name="content"/>
          <NuxtPage/>
        </div>
        <aside
          id="sidenav"
          ref="refSidenav"
          class="flex-grow h-min md:sticky top-4 break-words space-y-2 rounded-xl md:max-w-[250px] md:min-w-[250px] lg:max-w-[370px] lg:min-w-[370px]"
          >
          <slot name="sidenav" />
        </aside>
      </div>
      <div id="post" class="max-w-screen-xl m-auto">
        <!--  -->
      </div>
    </div>
    <br>
    <br>
  </div>
</template>

<script setup lang="ts">
const refSidenav = ref<HTMLElement | null>(null)
</script>
